// Module
var code = "<div class=\"container-fluid\">\n  <div class=\"row\">\n    <div class=\"col-md-12\">\n      <h1>伊万里市の情報</h1>\n\n      <h2>\n        <a class=\"CityInfoPage__openRiverInfo\" href=\"#\"> 河川水位情報 </a>\n      </h2>\n\n      <h2 class=\"CityInfoPage__kouhou\">伊万里市の広報</h2>\n    </div>\n  </div>\n</div>\n";
// Exports
export default code;